export enum MeasurementSystem {
  METRIC = 'METRIC',
  IMPERIAL = 'IMPERIAL',
}

export const appMeasurementSystem = MeasurementSystem;

export type Locale = {
  measurementSystem: MeasurementSystem;
  region: string;
  temperatureUnit: string;
  temperatureFormat: string;
  timeFormat: string;
  dateFormat: string;
  dateTimeFormat: string;
  fullDateTimeFormat: string;
};

export const timeFormatWorld = 'HH:mm';
export const timeFormatUs = 'h:mm a';

export const dateFormatWorld = 'dd.MM.yyyy';
export const dateFormatUs = 'MM.dd.yyyy';

export const dateTimeWorldFormat = 'DD.MM.yyyy HH:mm';
export const dateTimeUsFormat = 'MM.DD.yyyy h:mm a';

export const fullDateTimeWorldFormat = 'dd.MM.yyyy HH:mm:ss';
export const fullDateTimeUsFormat = 'MM.dd.yyyy h:mm:ss a';

export const datePickerWorldFormat = 'yyyy-MM-dd';
export const datePickerUsFormat = 'MM-dd-yyyy';

export const datePickerDateFormatMap = {
  IMPERIAL: datePickerUsFormat,
  METRIC: datePickerWorldFormat,
};

export const locale: Locale = {
  measurementSystem: MeasurementSystem.METRIC,
  region: 'world',
  temperatureUnit: '°C',
  temperatureFormat: 'celsius',
  timeFormat: timeFormatWorld,
  dateFormat: dateFormatWorld,
  dateTimeFormat: `${dateFormatWorld} ${timeFormatWorld}`,
  fullDateTimeFormat: fullDateTimeWorldFormat,
};

export const localeUs: Locale = {
  measurementSystem: MeasurementSystem.IMPERIAL,
  region: 'us',
  temperatureUnit: '°F',
  temperatureFormat: 'fahrenheit',
  timeFormat: timeFormatUs,
  dateFormat: dateFormatUs,
  dateTimeFormat: `${dateFormatUs} ${timeFormatUs}`,
  fullDateTimeFormat: fullDateTimeUsFormat,
};

export enum DefaultText {
  NOT_AVAILABLE = '-',
}

export enum CardListStatus {
  NORMAL = 'normal',
  MEDIUM = 'medium',
  HIGH = 'high',
  HIGHEST = 'highest',
}
